import { db } from "../firebase";
import { collection, addDoc, updateDoc, setDoc, doc, getDocs, query, orderBy, serverTimestamp, increment, arrayUnion } from "firebase/firestore";

const COLLECTION = "applications";

// ── Visitor & session identity ────────────────────────────────────────────────

function getVisitorId() {
    let id = localStorage.getItem("extern_visitor_id");
    if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem("extern_visitor_id", id);
    }
    return id;
}

function getSessionId() {
    let id = sessionStorage.getItem("extern_session_id");
    if (!id) {
        id = crypto.randomUUID();
        sessionStorage.setItem("extern_session_id", id);
    }
    return id;
}

export async function logPageVisit(path) {
    const visitorId = getVisitorId();
    const sessionId = getSessionId();
    const isNewVisitor = !localStorage.getItem("extern_visitor_seen");
    const isNewSession = !sessionStorage.getItem("extern_session_started");
    const now = new Date().toISOString();

    const visitorRef = doc(db, "visitors", visitorId);
    const sessionRef = doc(db, "visitors", visitorId, "sessions", sessionId);

    // Create or update visitor doc
    if (isNewVisitor) {
        await setDoc(visitorRef, { firstSeenAt: serverTimestamp(), lastSeenAt: serverTimestamp() });
        localStorage.setItem("extern_visitor_seen", "1");
    } else {
        await updateDoc(visitorRef, { lastSeenAt: serverTimestamp() });
    }

    // Create or update session doc
    if (isNewSession) {
        await setDoc(sessionRef, {
            startedAt: serverTimestamp(),
            lastActivityAt: serverTimestamp(),
            pages: [{ path, visitedAt: now }],
        });
        sessionStorage.setItem("extern_session_started", "1");
    } else {
        await updateDoc(sessionRef, {
            lastActivityAt: serverTimestamp(),
            pages: arrayUnion({ path, visitedAt: now }),
        });
    }
}

export async function createApplication(fields) {
    const ref = await addDoc(collection(db, COLLECTION), {
        ...fields,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
    });
    return ref.id;
}

// ── Financial Aid ─────────────────────────────────────────────────────────────

const FA_COLLECTION = "financialAid";

export async function createFinancialAid(fields) {
    const ref = await addDoc(collection(db, FA_COLLECTION), {
        ...fields,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
    });
    return ref.id;
}

export async function updateFinancialAid(docId, fields) {
    await updateDoc(doc(db, FA_COLLECTION, docId), {
        ...fields,
        updatedAt: serverTimestamp(),
    });
}

export async function getApplications() {
    const q = query(collection(db, COLLECTION), orderBy("createdAt", "desc"));
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function updateApplication(docId, fields, isRevision = false) {
    await updateDoc(doc(db, COLLECTION, docId), {
        ...fields,
        updatedAt: serverTimestamp(),
        ...(isRevision && {
            lastRevisedAt: serverTimestamp(),
            revisionCount: increment(1),
        }),
    });
}
